import React, { useEffect, useMemo, useState } from "react";

import { FaPlus } from "react-icons/fa6";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { QuizQuestionAPI } from "../../Api/QuizQuestions";
import SectionContainer from "../../Components/Container/SectionContainer";
import { Header, SearchInput } from "../../Components/CustomComponent";
import QuizSchedule from "../../Components/QuizSchedule";
import { WEB_ROUTES } from "../../constants";
import styles from "./index.module.scss";
import { baseRoute } from "../../Helper";
import { replace } from "lodash";

export default function QuizHistory() {
  const navigate = useNavigate();
  const location = useLocation();

  const quizQuestionAPI = QuizQuestionAPI();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(null);

  const quiz_id = useMemo(() => location.state?.quiz_id, []);
  const status = useMemo(() => location.state?.status, []);

  const handleNavigate = () => {
    navigate(baseRoute(WEB_ROUTES.ADD_QUESTION), {
      state: { quiz_id: quiz_id },
    });
  };

  const { data = [], isFetching } = useQuery(
    ["quizz", quiz_id, "question", search, page],
    async () => {
      const params = {
        page: page,
        limit: 20,
        search: search,
      };
      const response = await quizQuestionAPI.getQuizQuestions(quiz_id, params);
      setPagination(response.links);
      return response.data;
    },
    {
      enabled: !!quiz_id,
      keepPreviousData: false,
    }
  );

  const getRecords = async () => {
    try {
      let temp = page;
      temp = temp + 1;
      setPage(temp);
    } catch (e) { }
  };

  useEffect(() => {
    if (!quiz_id) {
      navigate(baseRoute(WEB_ROUTES.QUIZ, { replace: true }));
    }
  }, []);

  return (
    <div className={`${styles.Quiz}`}>
      <SectionContainer classes={`${styles.container} mx-auto`}>
        <Header text="Organize Quiz" />

        <div className={`${styles.serch_div} d-flex flex-column gap-35 mt-3`}>
          <div className="d-flex flex-row align-items-center justify-content-between gap-2">
            <SearchInput setValue={setSearch} value={search} />
          </div>
        </div>
      </SectionContainer>

      <QuizSchedule
        isQuiz={true}
        data={data}
        status={status}
        isLoading={isFetching}
        pagination={pagination}
        getRecords={getRecords}
        page={page}
      />
      {(status === 10) && (
        <div className={`${styles.addButton}`}>
          <div className={styles.addInner} onClick={handleNavigate}>
            <FaPlus size={50} />
          </div>
        </div>
      )}
    </div>
  );
}
